import { trans } from "src/translations";

export const META_FIELDS = {
  appId: "provider_id",
  appMode: "appMode",
  targets: "targets",
};

export const APP_MODE_RADIO_FIELD = {
  label: "Select app type",
  values: [
    { label: "External", value: "external", dataTestId: "appMode-external" },
    { label: "TiVo Apps", value: "tivo", dataTestId: "appMode-tivo" },
    { label: "Vewd Apps", value: "vewd", dataTestId: "appMode-vewd" },
  ],
  name: META_FIELDS.appMode,
};

export const MANIFEST_ERROR_FIELD = "manifest_error"; // this fields is only used to store errors

export const SWITCH_LABEL = trans.APP_MANIFESTS_TARGET_TAB_SWITCH_LABEL();

export const getSelectOption = (name, label, value) => ({
  label,
  name,
  value,
});

// Content of this array is added later below
// It contains list of fields that need to be converted between form & request
export const BOOL_FIELDS_CONVERSION = [];

export const getBoolSelectField = (fieldName) => {
  BOOL_FIELDS_CONVERSION.push(fieldName);
  return {
    name: fieldName,
    type: "select",
    values: [
      getSelectOption(fieldName, trans.APP_DETAILS_MANIFEST__FIELD_EMPTY(), ""),
      getSelectOption(
        fieldName,
        trans.APP_DETAILS_MANIFEST__FIELD_BOOL_TRUE(),
        "true"
      ),
      getSelectOption(
        fieldName,
        trans.APP_DETAILS_MANIFEST__FIELD_BOOL_FALSE(),
        "false"
      ),
    ],
  };
};

export const FIELD_DESCRIPTION = {
  allows_audio_only_playback: trans.APP_DETAILS_MANIFEST__FIELD_AUDIO_ONLY,
  allow_scripts_to_close_windows:
    trans.APP_DETAILS_MANIFEST__FIELD_CLOSE_WINDOW,
  background_persistence: trans.APP_DETAILS_MANIFEST__FIELD_BG_PERSISTENCE,
  tts_controlled_by_platform:
    trans.APP_DETAILS_MANIFEST__FIELD_TTS_CONTROLLED_BY_PLATFORM,
  block_mixed_active_content:
    trans.APP_DETAILS_MANIFEST__FIELD_MIXED_ACTIVE_CONTENT,
  block_mixed_fetch_content:
    trans.APP_DETAILS_MANIFEST__FIELD_MIXED_FETCH_CONTENT,
  block_mixed_xhr_content: trans.APP_DETAILS_MANIFEST__FIELD_MIXED_XHR_CONTENT,
  custom: trans.APP_DETAILS_MANIFEST__FIELD_CUSTOM,
  default_background_color: trans.APP_DETAILS_MANIFEST__FIELD_BACKGROUND,
  app_icon: trans.APP_DETAILS_MANIFEST__FIELD_APP_ICON,
  app_label: trans.APP_DETAILS_MANIFEST__FIELD_APP_LABEL,
  force_enable_virtual_keyboard:
    trans.APP_DETAILS_MANIFEST__FIELD_VIRTUAL_KEYBOARD,
  full_screen_virtual_keyboard:
    trans.APP_DETAILS_MANIFEST__FULL_SCREEN_VIRTUAL_KEYBOARD,
  history_on_back: trans.APP_DETAILS_MANIFEST__FIELD_HISTORY_BACK,
  input_method: trans.APP_DETAILS_MANIFEST__FIELD_INPUT_METHOD,
  no_cors_header_guard: trans.APP_DETAILS_MANIFEST__FIELD_CORS_GUARD,
  resolution: trans.APP_DETAILS_MANIFEST__FIELD_RESOLUTION,
  spatial_navigation_enabled: trans.APP_DETAILS_MANIFEST__FIELD_SPATNAV,
  transparent: trans.APP_DETAILS_MANIFEST__FIELD_TRANSPARENT,
  type: trans.APP_DETAILS_MANIFEST__FIELD_TYPE,
  user_agent: trans.APP_DETAILS_MANIFEST__FIELD_USER_AGENT,
  xhr_origin_check_enabled: trans.APP_DETAILS_MANIFEST__FIELD_CORS,
  zoom: trans.APP_DETAILS_MANIFEST__FIELD_ZOOM,
};

export const FIELDS = {
  allows_audio_only_playback: getBoolSelectField("allows_audio_only_playback"),
  allow_scripts_to_close_windows: getBoolSelectField(
    "allow_scripts_to_close_windows"
  ),
  tts_controlled_by_platform: getBoolSelectField("tts_controlled_by_platform"),
  block_mixed_active_content: getBoolSelectField("block_mixed_active_content"),
  block_mixed_fetch_content: getBoolSelectField("block_mixed_fetch_content"),
  block_mixed_xhr_content: getBoolSelectField("block_mixed_xhr_content"),
  custom: {
    name: "custom",
    type: "array",
  },
  default_background_color: {
    name: "default_background_color",
    type: "color",
  },
  app_label: { name: "app_label", type: "text" },
  background_persistence: {
    name: "background_persistence",
    type: "select",
    values: [
      getSelectOption(
        "bgPersistence",
        trans.APP_DETAILS_MANIFEST__FIELD_EMPTY(),
        ""
      ),
      getSelectOption(
        "bgPersistence",
        trans.APP_DETAILS_MANIFEST__FIELD_NONE(),
        "NONE"
      ),
      getSelectOption(
        "bgPersistence",
        trans.APP_DETAILS_MANIFEST__FIELD_LOW(),
        "LOW"
      ),
      getSelectOption(
        "bgPersistence",
        trans.APP_DETAILS_MANIFEST__FIELD_MEDIUM(),
        "MEDIUM"
      ),
      getSelectOption(
        "bgPersistence",
        trans.APP_DETAILS_MANIFEST__FIELD_HIGH(),
        "HIGH"
      ),
    ],
  },
  app_icon: {
    name: "app_icon",
    type: "image",
    meta: { maxSize: 1024 * 1024 },
  },
  force_enable_virtual_keyboard: getBoolSelectField(
    "force_enable_virtual_keyboard"
  ),
  full_screen_virtual_keyboard: getBoolSelectField(
    "full_screen_virtual_keyboard"
  ),
  history_on_back: getBoolSelectField("history_on_back"),
  input_method: {
    name: "input_method",
    type: "select",
    values: [
      getSelectOption(
        "inputMethod",
        trans.APP_DETAILS_MANIFEST__FIELD_EMPTY(),
        ""
      ),
      getSelectOption(
        "inputMethod",
        trans.APP_DETAILS_MANIFEST__FIELD_SPATNAV_VIRTUAL(),
        "virtual_keyboard"
      ),
      getSelectOption("inputMethod", "Multitap", "multitap"),
      getSelectOption(
        "inputMethod",
        trans.APP_DETAILS_MANIFEST__FIELD_SPATNAV_OMI(),
        "omi_events"
      ),
    ],
  },
  key_remapping: {
    name: "key_remapping",
    type: "array",
  },
  no_cors_header_guard: getBoolSelectField("no_cors_header_guard"),
  resolution: {
    name: "resolution",
    type: "resolution",
  },
  spatial_navigation_enabled: getBoolSelectField("spatial_navigation_enabled"),
  type: {
    name: "type",
    type: "select",
    values: [
      getSelectOption("type", trans.APP_DETAILS_MANIFEST__FIELD_EMPTY(), ""),
      getSelectOption(
        "type",
        trans.APP_DETAILS_MANIFEST__FIELD_TYPE_CSP(),
        "csp"
      ),
      getSelectOption(
        "type",
        trans.APP_DETAILS_MANIFEST__FIELD_TYPE_STORE(),
        "store"
      ),
      getSelectOption(
        "type",
        trans.APP_DETAILS_MANIFEST__FIELD_TYPE_HBBTV(),
        "hbbtv"
      ),
    ],
  },
  transparent: getBoolSelectField("transparent"),
  user_agent: { name: "user_agent", type: "text" },
  user_script: { name: "user_script", type: "javascript" },
  xhr_origin_check_enabled: getBoolSelectField("xhr_origin_check_enabled"),
  zoom: { name: "zoom", type: "number", min: 0.01 },
};

export const ENCODED_FIELDS_KEYS = [FIELDS.user_script.name];

export const IMAGE_FIELDS_KEYS = [FIELDS.app_icon.name];

export const TABS = [
  {
    path: "target",
    text: "Target",
    dataTestId: "manifest-target-tab",
    validateFields: [META_FIELDS.appId, META_FIELDS.targets],
  },
  {
    path: "manifest",
    text: "Manifest",
    dataTestId: "manifest-manifest-tab",
    validateFields: [
      FIELDS.resolution.name,
      FIELDS.zoom.name,
      FIELDS.default_background_color.name,
      FIELDS.key_remapping.name,
      FIELDS.custom.name,
      FIELDS.user_script.name,
      MANIFEST_ERROR_FIELD,
    ],
  },
];
